import type { Session } from '@conference/shared';

export function previewCopilotResponse(screen: string) {
  if (screen === 'paper') {
    return 'This paper turns collaborative innovation into practical steps: align stakeholders, test assumptions early, and measure outcomes together.';
  }
  if (screen === 'session') {
    return 'For this session, review the core topic, note one question for the speaker, and connect the examples to your own work.';
  }
  return 'Start with **Opening keynote: Designing what comes next** at 9:00 AM in the Main Hall. I can also help you explore speakers, papers, and sessions in this event.';
}

export function previewPaperInsight(title: string) {
  return `${title} turns collaborative innovation into practical steps.\n- Connects the event topic to real-world decisions\n- Offers a framework attendees can discuss and apply`;
}

export function previewSessionBrief(session: Pick<Session, 'title'>) {
  return `## Session prep\n\n${session.title} will help attendees turn ideas into a practical action plan.\n\n- Review one challenge you want to solve\n- Prepare a question for the facilitator\n- Note one action to try after the session`;
}
